import {
  ShirtIcon,
  BedDoubleIcon,
  ArchiveIcon,
  BrushIcon,
  BlindsIcon,
  SofaIcon,
  CookingPotIcon,
  DropletsIcon,
  PawPrintIcon,
  BriefcaseIcon,
  Building2Icon,
  HelpCircleIcon,
} from 'lucide-react'
import type { ExtraService } from '../types'

export const extraServices: ExtraService[] = [
  { id: 'laundry', icon: ShirtIcon, label: { en: 'Laundry & Folding', es: 'Lavado y Doblado' } },
  { id: 'beds', icon: BedDoubleIcon, label: { en: 'Bed Making', es: 'Tender Camas' } },
  { id: 'closets', icon: ArchiveIcon, label: { en: 'Organize Closets', es: 'Organizar Clósets' } },
  { id: 'carpet', icon: BrushIcon, label: { en: 'Deep Carpet Cleaning', es: 'Limpieza Profunda de Alfombras' } },
  { id: 'windows', icon: BlindsIcon, label: { en: 'Window Cleaning', es: 'Limpieza de Ventanas' } },
  { id: 'furniture', icon: SofaIcon, label: { en: 'Furniture Organization', es: 'Organización de Muebles' } },
  { id: 'kitchen', icon: CookingPotIcon, label: { en: 'Kitchen Deep Clean', es: 'Limpieza Profunda de Cocina' } },
  { id: 'bathroom', icon: DropletsIcon, label: { en: 'Bathroom Sanitizing', es: 'Desinfección de Baños' } },
  { id: 'pets', icon: PawPrintIcon, label: { en: 'Pet Area Cleaning', es: 'Limpieza de Área de Mascotas' } },
  { id: 'office', icon: BriefcaseIcon, label: { en: 'Office Cleaning', es: 'Limpieza de Oficinas' } },
  { id: 'commercial', icon: Building2Icon, label: { en: 'Commercial Spaces', es: 'Espacios Comerciales' } },
  {
    id: 'other',
    icon: HelpCircleIcon,
    label: { en: 'Other Services — Contact for Quote', es: 'Otros Servicios — Cotización' },
  },
]
